import {
  BillingFrequency,
  ServiceDuration,
  ServiceItem
} from "@/pages/settings/pages/products-v2/types";

// Stands in for the missing tier id of a flexible service's single Terms entry.
export const FLEXIBLE_TERM_ID = "flexible";

export interface DealServiceLine {
  key: string;
  service: ServiceItem;
  pricingId: string;
  quantity: number;
  duration: ServiceDuration | null;
  billingFrequency: BillingFrequency | null;
  price: number;
}
